'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectBuildingsCtrl', ProjectBuildingsCtrl);

  ProjectBuildingsCtrl.$inject = ['$scope', 'Project', 'Auth', 'Utils', 'Constants', 'errorMessageService',
    '$stateParams', 'ProjectDataservice', '$mdDialog', 'Labels', '$injector', 'sg2BuildingService'];

  function ProjectBuildingsCtrl ($scope, Project, Auth, Utils, Constants, errorMessageService,
    $stateParams, ProjectDataservice, $mdDialog, Labels, $injector, sg2BuildingService) {

    const vm = this;

    $scope.LABELS = Labels;

    vm.qualityLevels = Constants.getList('QUALITY_LEVELS');

    vm.$onInit = function () {
      vm.addOriginalBuildingProperty();
      vm.canWrite = Utils.isUserManager(Auth, vm.project);
      setTimeout(() => {
        $scope.sg2AuthService = $injector.get('sg2AuthService');
      }, 100);
    };

    vm.addOriginalBuildingProperty = function () {
      if (vm.project && vm.project.buildings) {
        vm.project.buildings = vm.project.buildings.map((i) => {
          i.originalName = i.name.slice();
          return i;
        });
      }
    };

    vm.submit = function (form) {
      sg2BuildingService.patch(sg2BuildingService.getBuilding(form._id), {
        name: form.name,
        qualityLevel: form.qualityLevel
      });
    };

    vm.removeBuilding = function removeBuilding (buildingId, evt) {
      sg2BuildingService.delete(sg2BuildingService.getBuilding(buildingId), true);
    };
  }
})();
